import { Validators } from '@angular/forms';
import { FieldViews, IFieldContainer, IFieldDefinition, IFormConfig, InputTypes, ValueTypes } from 'app/interfaces';
import { IDataContainerService } from 'app/interfaces/data-container.interface';
import { channelDefaultCustomerFields } from '../../fields/channels/default-customer.fields';

const formFields: (IFieldContainer|IFieldDefinition)[] = [
	channelDefaultCustomerFields.get('entity_customer.entity_customer_id'),
	channelDefaultCustomerFields.get('entity_customer.description'),
	{
		key: 'external_sync_operations',
		name: 'Esporta dati verso esterno',
		inputType: InputTypes.SELECT,
		valueType: ValueTypes.NUMBER,
		formValidators: [ Validators.required ],
		options: [
			{
				label: 'Abilitato',
				value: 1
			},
			{
				label: 'Disabilitato',
				value: 0
			}
		],
		defaultValue(dataContainerService: IDataContainerService) {
			return 'channels.totem';
		}
	},
	{
		key: 'scenario',
		name: '',
		inputType: InputTypes.HIDDEN,
		valueType: ValueTypes.STRING,
		fieldView: FieldViews.HIDDEN,
		formValidators: [ Validators.required ],
		defaultValue(dataContainerService: IDataContainerService) {
			return 'channels.totem';
		}
	}
];

const totemForm: IFormConfig = {
	editTitle: 'Modifica Configurazioni Totem',
	fields: formFields 
};

export default totemForm;
